<template>
  <div>
    <component
      :is="elem.component"
      v-for="elem in components"
      :key="elem.key"
      v-model="elem.value"
      v-bind="elem.options || {}"
      v-on="elem.on"
      @input="onInput(elem)"
    >
      <!-- Components may contain slots but this is mainly for content rendering -->
      <component
        :is="slot.component"
        v-for="(slot, index) in elem.slots"
        :key="index"
      >
        {{ slot.content }}
      </component>
    </component>
  </div>
</template>

<script>
/**
 * List of any components.
 *
 * @vue-prop {Object} value - Required. Array of components
 * @vue-prop {Boolean} sendCallbacks - If true and options' callback is secified,
 *                     thay will be called
 *
 * @vue-event {VueComponent} editionStart - Emitted after created's nextTick
 * @vue-event {Object} edit - Triggered on any edit of an item of the array
 */
// Components
import AdvancedTeamPicker from '@/components/advanced-team-picker.vue';
import AutonomousFileChipList from '@/components/file-system/autonomous-file-chip-list.vue';
import Checkbox from '@/components/checkbox.vue';
import CheckboxList from '@/components/checkbox-list.vue';
import EditableLabel from '@/components/editable-label.vue';
import EditableLabelRadio from '@/components/editable-label-radio.vue';
import ExpandableColorPicker from '@/components/expandable-color-picker.vue';
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import ExpandableWidgetDesign from '@/components/expandable-widget-design.vue';
import HideIndicatorsOptionsField from '@/components/hide-indicators-options-field.vue';
import ImpactSelector from '@/components/impact-selector.vue';
import IndicatorDisplayConfigField from '@/components/indicator-display-config-field.vue';
import InputNumber from '@/components/input-number.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
import MinMaxSelector from '@/components/min-max-selector.vue';
import PlusMinusButtons from '@/components/plus-minus-buttons.vue';
import RadioGroup from '@/components/radio-group.vue';
import SortablePagePickers from '@/components/sortable-page-pickers.vue';
import TextAlignSelector from '@/components/text-align-selector.vue';
import Tree from '@/components/tree.vue';
import TreeField from '@/components/tree-field.vue';

export default {
  name: 'ComponentsList',
  components: {
    AdvancedTeamPicker,
    AutonomousFileChipList,
    Checkbox,
    CheckboxList,
    EditableLabel,
    EditableLabelRadio,
    ExpandableColorPicker,
    ExpandableSettingsItem,
    ExpandableWidgetDesign,
    HideIndicatorsOptionsField,
    ImpactSelector,
    IndicatorDisplayConfigField,
    InputNumber,
    IntCheckbox,
    MinMaxSelector,
    PlusMinusButtons,
    RadioGroup,
    SortablePagePickers,
    TextAlignSelector,
    Tree,
    TreeField,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    sendCallbacks: Boolean,
  },
  data() {
    return {
      components: [],
    };
  },
  watch: {
    value(newVal) {
      this.editionStart(newVal);
    },
  },
  created() {
    this.editionStart(this.value);
  },
  methods: {
    editionStart(components) {
      this.components = components;
      this.$nextTick(() => {
        this.$emit('editionStart', this);
      });
    },
    onInput(elem) {
      if (this.sendCallbacks && typeof elem.callback === 'function') {
        elem.callback(elem);
      } else {
        this.$emit('edit', elem);
      }
    },
  },
};
</script>
